import { render } from "./OwnerList.vue?vue&type=template&id=1d2c2116&ts=true"
import script from "./OwnerList.vue?vue&type=script&lang=ts"
export * from "./OwnerList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__